import { getRewardImageUrl } from '../../utils/rewardMediaUrl';

const shuffle = (items) => {
  const arr = [...items];
  for (let i = arr.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  return arr;
};

export const buildSlidesFromRewards = (rewards = []) =>
  rewards
    .map((reward) => {
      const src = getRewardImageUrl(reward.image);
      return src ? { id: reward.documentId, src, alt: reward.name } : null;
    })
    .filter(Boolean);

export const buildRewardSetSlides = (
  rewardSet,
  { shuffle: doShuffle = false } = {}
) => {
  const fromRewards = buildSlidesFromRewards(rewardSet?.rewards);
  if (fromRewards.length > 0) {
    return doShuffle ? shuffle(fromRewards) : fromRewards;
  }

  const coverSrc = getRewardImageUrl(rewardSet?.coverImage);
  if (coverSrc) {
    return [
      {
        id: rewardSet?.documentId || 'cover',
        src: coverSrc,
        alt: rewardSet?.name || 'Copertina',
      },
    ];
  }

  return [];
};

export const buildCatalogSlides = (
  sets = [],
  { shuffle: doShuffle = false } = {}
) => {
  const slides = sets.flatMap((set) => buildSlidesFromRewards(set.rewards));
  return doShuffle ? shuffle(slides) : slides;
};
